/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { RiskPolicy, RiskPolicy$inboundSchema } from "./riskpolicy.js";

export type ListRiskPoliciesResult = {
  /**
   * The list of risk policies.
   */
  policies: Array<RiskPolicy>;
};

/** @internal */
export const ListRiskPoliciesResult$inboundSchema: z.ZodMiniType<
  ListRiskPoliciesResult,
  unknown
> = z.object({
  policies: z.array(RiskPolicy$inboundSchema),
});

export function listRiskPoliciesResultFromJSON(
  jsonString: string,
): SafeParseResult<ListRiskPoliciesResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListRiskPoliciesResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListRiskPoliciesResult' from JSON`,
  );
}
